import PropTypes from "prop-types"
import React from "react"

import Tooltip from "src/components/Tooltip"

export const DOCKWA_ACCOUNT_TOOLTIP = {
  linked:
    "This boater has connected their Dockwa account. They can manage payments and sign contracts, and they're responsible for updating their insurance, account and boat information.",
  notLinked:
    "This boater hasn't connected their Dockwa account. You will need to manage payments, insurance and boat information for them. Ask them to connect a Dockwa account if you'd rather they manage this themselves.",
}

const DockwaAccountIndicator = ({ linked, tooltip = false }) => {
  const content = linked ? (
    <span className="inline-flex items-center gap-1">
      <i className="fa-solid fa-link text-teal-500" />
      <span>Linked</span>
    </span>
  ) : (
    <span className="inline-flex items-center gap-1">
      <i className="fa-solid fa-link-slash text-gray-600" />
      <span>Not linked</span>
    </span>
  )

  if (!tooltip) return content

  return (
    <Tooltip
      text={
        linked
          ? DOCKWA_ACCOUNT_TOOLTIP.linked
          : DOCKWA_ACCOUNT_TOOLTIP.notLinked
      }
      placement="top"
      variant="dark"
      maxWidth="320px"
    >
      {content}
    </Tooltip>
  )
}

DockwaAccountIndicator.propTypes = {
  linked: PropTypes.bool.isRequired,
  tooltip: PropTypes.bool,
}

export default DockwaAccountIndicator
